export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14975.9e7a3e83.jpg";